import {VideoUploadModalWrapper} from '@features/video-upload/components/video-upload-modal-wrapper'
import {ModalBody, ModalFooter} from '@components/ui/modal-atoms'
import {Dropzone} from '@components/ui/dropzone'
import {useDropzone} from 'react-dropzone'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {Image01Icon} from '@components/ui/icon'
import {Button} from '@components/ui/button'
import {cn, errorHandler} from '@utilities/helpers.ts'
import {Spinner} from '@components/ui/spinner'
import {useUploadMediaLink} from '@features/video-upload/queries/useUploadMediaLink.ts'

export const IdleStep = () => {
    const {t} = useTranslation()
    const assignmentId = useVideoUpload(store => store.assignmentId)
    const setDropzoneFile = useVideoUpload(store => store.setDropzoneFile)
    const dropzoneFile = useVideoUpload(store => store.dropzoneFile)
    const setStep = useVideoUpload(store => store.setStep)
    const setFile = useVideoUpload(store => store.setFile)
    const setLinkMediaToUpload = useVideoUpload(store => store.setLinkMediaToUpload)
    const step = useVideoUpload(store => store.step)
    const dropzone = useDropzone({
        accept: {
            'video/mp4v': ['.mp4v'],
            'video/mpg4': ['.mpg4'],
            'video/mp4': ['.mp4'],
            'video/qt': ['.qt'],
            'video/quicktime': ['.mov'],
            'video/jpgv': ['.jpgv']
        },
        maxFiles: 1,
        onDropAccepted: ([file]) => setDropzoneFile(file)
    })
    const uploadMediaLinkMutation = useUploadMediaLink({
        onError: errorHandler,
        onMutate: () => setStep('gettingLink'),
        onSuccess: data => {
            setLinkMediaToUpload(data.presigned_url)
            setFile(data.media)
            setStep('uploading')
        }
    })

    return (
        <VideoUploadModalWrapper>
            <ModalBody>
                <Dropzone state={dropzone}>
                    <div
                        className={cn(
                            'flex min-h-[142px] cursor-pointer flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-neutral-300 bg-white p-7',
                            '[&_p]:max-w-full [&_p]:overflow-x-hidden [&_p]:text-ellipsis [&_p]:whitespace-nowrap [&_p]:text-sm [&_p]:text-black',
                            '[&_p_span]:underline [&_p_span]:[text-underline-offset:2px]',
                            '[&_svg]:fill-neutral-500',
                            dropzone.isDragReject && 'border-danger-600 bg-danger-50',
                            dropzone.isDragAccept && 'border-success-600 bg-success-50'
                        )}
                    >
                        {dropzoneFile ? (
                            <p>{dropzoneFile.name}</p>
                        ) : (
                            <>
                                <Image01Icon size={24} />
                                <p>{t('single_shooting:drop_video')}</p>
                                <p>
                                    <Trans i18nKey="assignment:or_upload" components={{span: <span />}} />
                                </p>
                            </>
                        )}
                    </div>
                </Dropzone>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="w-full"
                    disabled={!dropzoneFile || step == 'gettingLink'}
                    onClick={() => uploadMediaLinkMutation.mutate({assignmentId, fileName: dropzoneFile?.name})}
                >
                    {t('admin:upload')}
                    {step == 'gettingLink' && <Spinner />}
                </Button>
            </ModalFooter>
        </VideoUploadModalWrapper>
    )
}
